import React from 'react';

import BasePage from './BasePage';
import ConnectedSearchBaseScreen from '../SearchApp/containers/ConnectedSearchBaseScreen';
import withCookieHeaderHeight from '../components/withCookieHeaderHeight';
import { HEADER_HEIGHT } from '../SearchApp/constants';

class SearchPage extends React.Component {
    render() {
        return (
            <BasePage {...this.props} isSearchPage={true}>
                <div
                    className="feed-search-page"
                    style={{
                        paddingTop:
                            this.props.cookieHeaderHeight + HEADER_HEIGHT,
                    }}
                >
                    <ConnectedSearchBaseScreen {...this.props} />
                </div>
            </BasePage>
        );
    }
}

export default withCookieHeaderHeight(SearchPage);
